import React from "react";
import { Button } from 'react-bootstrap';
import { Authorization } from 'components/Authorization';
import { userRoles as roles } from '_constants';
import styles from "../Styles.module.css"

/**
 * @author Teyim Pila <teyim.pila@gmail.com>
 * @date 20/12/2018 : 10:28 AM
 */
const currentUser = localStorage.user;
const BillingAdminAuth = Authorization([roles.BILLING_ADMIN_ROLE]) ||
        currentUser.username === 'aniekan-teams@chatdesk.com';

const generalSettings = (props) => (
    <div>
        <Button className={props.settings.isDispatchEnabled ? 'btn-danger' : 'btn-success'}
                onClick={() => props.updateSystemSettings({
                    ...props.settings,
                    isDispatchEnabled: !props.settings.isDispatchEnabled
                })}>
            {props.settings.isDispatchEnabled ? 'Disable Dispatcher' : 'Enable Dispatcher'}
        </Button>
        <div className={styles.mt10}>
            <Button className={props.settings.isStripeEnabled ? 'btn-danger' : 'btn-success'}
                    onClick={() => props.updateSystemSettings({
                        ...props.settings,
                        isStripeEnabled: !props.settings.isStripeEnabled
                    })}>
                {props.settings.isStripeEnabled ? 'Disable Stripe' : 'Enable Stripe'}
            </Button>
        </div>
        {BillingAdminAuth &&
            <div className={styles.mt10}>
                <div className={styles.w30Percent}>
                    <span className="font-14 color-grey-dark">Delete All Messages Earlier Than:</span>
                    <label className="calendar-today tms-inbox-calendar display-block">
                        <input className={styles.widthFull} type={"date"} name={"endDate"} value={props.endDate} onChange={props.handleChange} />
                    </label>
                    <Button className="btn-danger"
                            onClick={props.deleteAzurePayload}>
                        Delete Azure Payload
                    </Button>
                </div>
            </div>
        }
        <div className={styles.mt10}>
            <hr />
            <div className={styles.w30Percent}>
                <Button className="btn-info"
                        onClick={props.jiraOauth}>
                    Perform Jira Oauth
                </Button>
            </div>
        </div>
    </div>
);


export default generalSettings



